function cardTooltip() {
  const atcCards = document.querySelectorAll('.atc-card')
  // Store last selected options for each product
  const lastSelectedOptions = new Map()

  // Set z-index for all custom product card container parents
  const customProductContainers = document.querySelectorAll(
    '.custom-product-card-container'
  )
  customProductContainers.forEach((container) => {
    if (container.parentElement) {
      container.parentElement.style.zIndex = '1'
    }
  })

  // Money formatter helper function
  const formatMoney = (centsInput) => {
    const cents =
      typeof centsInput === 'string' ? centsInput.replace('.', '') : centsInput
    const symbol = window.mitoq.currency.symbol ?? '$'
    if (symbol === '€') {
      return `${symbol}${(cents / 100).toFixed(2).replace('.', ',')}`
    }
    return `${symbol}${(cents / 100).toFixed(2)}`
  }

  // Function to update cart
  const updateCart = async (variantId, confirmButton, sellingPlanId = null) => {
    try {
      // Prepare the add to cart data
      const addData = {
        items: [
          {
            id: variantId,
            quantity: 1,
          },
        ],
      }

      // If there's a selling plan ID, add it to the item
      if (sellingPlanId) {
        addData.items[0].selling_plan = sellingPlanId
      }

      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(addData),
      })

      if (!addResponse.ok) {
        throw new Error('Failed to add item to cart')
      }

      // Get fresh cart data for both sections
      const sections = ['cart-drawer', 'cart-icon-bubble']
      const cartResponse = await fetch(`?sections=${sections.join(',')}`)
      if (!cartResponse.ok) {
        throw new Error('Failed to get updated cart data')
      }

      const cartData = await cartResponse.json()
      const parsedHTML = new DOMParser().parseFromString(
        cartData['cart-drawer'],
        'text/html'
      )
      const newDrawerInner = parsedHTML.querySelector('.drawer__inner')

      // Parse cart icon bubble section
      const cartIconBubbleHTML = new DOMParser().parseFromString(
        cartData['cart-icon-bubble'],
        'text/html'
      )
      const newCartCount = cartIconBubbleHTML.querySelector(
        '.cart-count-bubble span[aria-hidden="true"]'
      )

      if (!newDrawerInner) {
        throw new Error('Could not find drawer inner in response')
      }

      // Update the cart drawer content
      const cartDrawer = document.querySelector('cart-drawer')

      if (cartDrawer) {
        const drawerInnerElement = cartDrawer.querySelector('.drawer__inner')

        if (!drawerInnerElement) {
          throw new Error('Could not find drawer inner element')
        }

        // Check if cart is currently empty
        const wasEmpty = cartDrawer.classList.contains('is-empty')

        drawerInnerElement.innerHTML = newDrawerInner.innerHTML

        if (wasEmpty) {
          // Remove the is-empty class since we now have items
          cartDrawer.classList.remove('is-empty')
        }

        // Update cart count text
        if (newCartCount) {
          const currentCartCount = document.querySelector(
            '.cart-count-bubble span[aria-hidden="true"]'
          )
          if (currentCartCount) {
            currentCartCount.textContent = newCartCount.textContent
          }
        }

        // Use requestAnimationFrame to ensure DOM is updated before opening
        requestAnimationFrame(() => {
          // Open cart drawer
          cartDrawer.open()

          // Re-attach event listeners after a short delay
          setTimeout(() => {
            if (typeof cartDrawer.cartFooterAnimation === 'function') {
              cartDrawer.cartFooterAnimation()
            }
            if (typeof cartDrawer.rechargeChangeOption === 'function') {
              cartDrawer.rechargeChangeOption()
            }
          }, 100)
        })
      }

      // Close the tooltip
      const tooltip = confirmButton.closest('.atc-tooltip')
      const card = document.querySelector('.atc-card.active')
      if (tooltip) {
        tooltip.classList.remove('active')
      }
      if (card) {
        card.classList.remove('active')
      }

      // Close the modal if it's open
      const atcPlanModal = document.getElementById('atc-plan-modal')
      if (atcPlanModal) {
        atcPlanModal.style.visibility = 'hidden'
        atcPlanModal.style.opacity = '0'
      }
    } catch (error) {
      console.error('Error updating cart:', error)
      throw error
    } finally {
      // Remove loading state regardless of success or failure
      confirmButton.classList.remove('is-loading')
    }
  }

  // Create a single modal instance
  const sellingPlanModal = document.createElement('div')
  sellingPlanModal.id = 'atc-plan-modal'
  sellingPlanModal.className = 'selling-modal-overlay'
  sellingPlanModal.style.visibility = 'hidden'
  sellingPlanModal.style.opacity = '0'

  const modalContent = document.createElement('div')
  modalContent.className = 'selling-modal-content'

  // Add close button to modal
  const modalCloseButton = document.createElement('button')
  modalCloseButton.className = 'selling-close-modal'
  modalCloseButton.setAttribute('aria-label', 'Close modal')
  modalCloseButton.innerHTML =
    '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.375 1.352l17.25 16.976M18.625 1.352L1.375 18.328" stroke="#8E8E8E" stroke-width="1.22" stroke-linecap="round" stroke-linejoin="round"></path></svg>'
  modalCloseButton.addEventListener('click', () => {
    sellingPlanModal.style.visibility = 'hidden'
    sellingPlanModal.style.opacity = '0'
    // Remove active class from atc-card when modal closes
    const activeCard = document.querySelector('.atc-card.active')
    if (activeCard) {
      activeCard.classList.remove('active')
    }
  })
  modalContent.appendChild(modalCloseButton)

  // Create container for modal plans
  const modalPlans = document.createElement('div')
  modalPlans.id = 'modal-selling-plans'
  modalContent.appendChild(modalPlans)

  sellingPlanModal.appendChild(modalContent)
  document.body.appendChild(sellingPlanModal)

  // Add click outside to close
  sellingPlanModal.addEventListener('click', (e) => {
    if (e.target === sellingPlanModal) {
      sellingPlanModal.style.visibility = 'hidden'
      sellingPlanModal.style.opacity = '0'
      // Remove active class from atc-card when modal closes
      const activeCard = document.querySelector('.atc-card.active')
      if (activeCard) {
        activeCard.classList.remove('active')
      }
    }
  })

  atcCards.forEach((card) => {
    // Create tooltip element for desktop
    const tooltip = document.createElement('div')
    tooltip.className = 'atc-tooltip'
    const tooltipId = `tooltip_${card.dataset.productId}_${Math.random().toString(36).substr(2, 9)}`
    tooltip.id = tooltipId

    // Get the data from the card
    const { sellingPlans: plansJSON, variants: variantsJSON } = card.dataset
    const productId =
      card.dataset.productId ||
      card.closest('[data-product-id]')?.dataset.productId
    let groups = []
    let variants = []
    try {
      groups = JSON.parse(unescape(plansJSON))
      variants = JSON.parse(unescape(variantsJSON))
    } catch (e) {
      console.warn('Error parsing JSON data:', e)
    }

    // Resolve the subscription option that matches the product's default_subscribe_variant
    // metafield, falling back to the 3-month subscription when the metafield is empty
    const defaultSubscribeVariantId = (
      card.dataset.defaultSubscribeVariantId || ''
    ).trim()
    const defaultSubscribeOptionValue = (() => {
      if (groups.length === 0) return null

      const planIds = new Set()
      groups.forEach((group) => {
        group.selling_plans.forEach((plan) => planIds.add(plan.id))
      })

      const optionValueFor = (variant) => {
        if (!variant || !variant.available) return null
        const allocation = (variant.selling_plan_allocations || []).find(
          (item) => planIds.has(item.selling_plan_id)
        )
        return allocation ? `sub_${allocation.selling_plan_id}` : null
      }

      if (defaultSubscribeVariantId) {
        const metafieldOption = optionValueFor(
          variants.find(
            (variant) => variant.id.toString() === defaultSubscribeVariantId
          )
        )
        if (metafieldOption) return metafieldOption
      }

      const threeMonthPattern = /(^|[^0-9])3\s*-?\s*(m|months?)\b/i
      const planNameById = new Map()
      groups.forEach((group) => {
        group.selling_plans.forEach((plan) => planNameById.set(plan.id, plan.name))
      })

      const threeMonthVariant = variants.find((variant) => {
        const optionValue = optionValueFor(variant)
        if (!optionValue) return false
        const planName = planNameById.get(Number(optionValue.replace('sub_', '')))
        return (
          threeMonthPattern.test(variant.title || '') ||
          threeMonthPattern.test(planName || '')
        )
      })
      return optionValueFor(threeMonthVariant)
    })()

    // Add class if product has only one variant
    const [firstVariant] = variants
    const { currentVariantId } = card.dataset
    if (
      variants.length === 1 &&
      firstVariant.id.toString() === currentVariantId &&
      (!groups || groups.length === 0)
    ) {
      card.classList.add('single-variant')
    }

    // Create tooltip content
    const tooltipContent = document.createElement('div')
    tooltipContent.className = 'tooltip-content'

    // Add selling-close-modal at the top
    const closeModal = document.createElement('button')
    closeModal.className = 'selling-close-modal'
    closeModal.setAttribute('aria-label', 'Close modal')
    closeModal.innerHTML =
      '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.375 1.352l17.25 16.976M18.625 1.352L1.375 18.328" stroke="#8E8E8E" stroke-width="1.22" stroke-linecap="round" stroke-linejoin="round"></path></svg>'
    closeModal.addEventListener('click', () => {
      tooltip.classList.remove('active')
      card.classList.toggle('active')
    })
    tooltipContent.appendChild(closeModal)

    let firstAvailableVariant = null
    let hasCheckedOption = false

    // Function to create purchase options (used by both tooltip and modal)
    const createPurchaseOptions = (container) => {
      // Create subscription section first
      if (groups.length > 0) {
        const subscriptionSection = document.createElement('div')
        subscriptionSection.className =
          'purchase-option-section subscribe-method'
        subscriptionSection.innerHTML = '<h3>Subscribe & Save</h3>'
        const plansList = document.createElement('ul')
        plansList.className = 'plans-list'

        let hasSubscriptionOptions = false

        groups.forEach((group) => {
          group.selling_plans.forEach((plan) => {
            const li = document.createElement('li')

            // Find the variant that supports this selling plan
            const compatibleVariant = variants.find((variant) => {
              return variant.selling_plan_allocations.some(
                (allocation) => allocation.selling_plan_id === plan.id
              )
            })

            if (!compatibleVariant) return // Skip if no compatible variant found

            // Get the selling plan allocation for this specific plan
            const sellingPlanAllocation =
              compatibleVariant.selling_plan_allocations.find(
                (allocation) => allocation.selling_plan_id === plan.id
              )

            // Get the correct prices
            const originalPrice = compatibleVariant.price
            const finalPrice = sellingPlanAllocation
              ? sellingPlanAllocation.price
              : originalPrice
            const hasDiscount = finalPrice < originalPrice

            // Check if the variant is sold out
            const isSoldOut = !compatibleVariant.available

            // Store the first available variant for subscription
            if (!hasCheckedOption && !isSoldOut && !firstAvailableVariant) {
              firstAvailableVariant = {
                type: 'subscription',
                variantId: compatibleVariant.id,
                planId: plan.id,
              }
            }

            const optionValue = `sub_${plan.id}`
            const lastSelectedOption = lastSelectedOptions.get(productId)
            const isLastSelected =
              lastSelectedOption && lastSelectedOption.value === optionValue

            let shouldCheck = false
            if (isLastSelected) {
              shouldCheck = true
            } else if (!lastSelectedOption && defaultSubscribeOptionValue) {
              shouldCheck = optionValue === defaultSubscribeOptionValue
            } else if (!lastSelectedOption && !hasCheckedOption && !isSoldOut) {
              shouldCheck = true
            }

            // Create elements directly
            const label = document.createElement('label')
            if (isSoldOut) label.classList.add('sold-out')

            const input = document.createElement('input')
            input.type = 'radio'
            input.name = `purchase_option_${tooltipId}`
            input.value = optionValue
            input.dataset.variantId = compatibleVariant.id
            input.dataset.sellingPlanId = plan.id
            if (isSoldOut) input.disabled = true
            if (shouldCheck) {
              input.checked = true
            }

            const optionDetails = document.createElement('div')
            optionDetails.className = 'option-details'

            const optionName = document.createElement('span')
            optionName.className = 'option-name'
            optionName.textContent = plan.name

            const priceDetails = document.createElement('div')
            priceDetails.className = 'price-details'

            if (hasDiscount) {
              const originalPriceElement = document.createElement('s')
              originalPriceElement.className = 'original-price'
              originalPriceElement.textContent = formatMoney(originalPrice)
              priceDetails.appendChild(originalPriceElement)
            }

            const finalPriceElement = document.createElement('span')
            finalPriceElement.className = 'final-price'
            finalPriceElement.innerHTML = `${formatMoney(finalPrice)} <span class="price--symbol">${Shopify.currency.active}</span>`

            if (isSoldOut) {
              const soldOutText = document.createElement('span')
              soldOutText.className = 'sold-out-text'
              soldOutText.textContent = 'Sold out'
              priceDetails.appendChild(soldOutText)
            }

            priceDetails.appendChild(finalPriceElement)
            optionDetails.appendChild(optionName)
            optionDetails.appendChild(priceDetails)
            label.appendChild(input)
            label.appendChild(optionDetails)
            li.appendChild(label)

            if (shouldCheck) {
              hasCheckedOption = true
            }
            plansList.appendChild(li)
            hasSubscriptionOptions = true
          })
        })

        subscriptionSection.appendChild(plansList)
        if (hasSubscriptionOptions) {
          container.appendChild(subscriptionSection)
        }
      }

      // Create one-time purchase section
      const oneTimeSection = document.createElement('div')
      oneTimeSection.className = 'purchase-option-section'
      oneTimeSection.innerHTML = '<h3>One-time purchase</h3>'
      const variantsList = document.createElement('ul')
      variantsList.className = 'variants-list'

      // Filter variants that don't have selling plans
      const oneTimeVariants = variants.filter((variant) => {
        return (
          !variant.selling_plan_allocations ||
          variant.selling_plan_allocations.length === 0
        )
      })

      let hasOneTimeOptions = false

      oneTimeVariants.forEach((variant) => {
        const li = document.createElement('li')
        const hasDiscount =
          variant.compare_at_price && variant.compare_at_price > variant.price

        // Get display name from the hidden variant data element
        const variantDataElement = document.querySelector(
          `.variant-data[data-id="${variant.id}"]`
        )
        // eslint-disable-next-line prefer-destructuring
        const { displayName } = variantDataElement?.dataset || {}
        let formattedTitle = displayName || variant.title

        // If no display name, use the month supply format
        if (!displayName) {
          if (variant.title.includes('1M')) {
            formattedTitle = '1-month supply'
          } else if (variant.title.includes('3M')) {
            formattedTitle = '3-month supply'
          } else if (variant.title.includes('6M')) {
            formattedTitle = '6-month supply'
          }
        }

        // Check if the variant is sold out
        const isSoldOut = !variant.available

        // Store the first available variant for one-time purchase if no subscription variant was found
        if (!hasCheckedOption && !isSoldOut && !firstAvailableVariant) {
          firstAvailableVariant = {
            type: 'one_time',
            variantId: variant.id,
          }
        }

        const optionValue = `one_time_${variant.id}`
        const lastSelectedOption = lastSelectedOptions.get(productId)
        const isLastSelected =
          lastSelectedOption && lastSelectedOption.value === optionValue

        // Create elements directly
        const label = document.createElement('label')
        if (isSoldOut) label.classList.add('sold-out')

        const input = document.createElement('input')
        input.type = 'radio'
        input.name = `purchase_option_${tooltipId}`
        input.value = optionValue
        input.dataset.variantId = variant.id
        if (isSoldOut) input.disabled = true
        if (
          (!hasCheckedOption && !isSoldOut && !lastSelectedOption) ||
          isLastSelected
        ) {
          input.checked = true
        }

        const optionDetails = document.createElement('div')
        optionDetails.className = 'option-details'

        const optionName = document.createElement('span')
        optionName.className = 'option-name'
        optionName.textContent = formattedTitle

        const priceDetails = document.createElement('div')
        priceDetails.className = 'price-details'

        if (hasDiscount) {
          const originalPrice = document.createElement('s')
          originalPrice.className = 'original-price'
          originalPrice.textContent = formatMoney(variant.compare_at_price)
          priceDetails.appendChild(originalPrice)
        }

        const finalPrice = document.createElement('span')
        finalPrice.className = 'final-price'
        finalPrice.innerHTML = `${formatMoney(variant.price)} <span class="price--symbol">${Shopify.currency.active}</span>`

        priceDetails.appendChild(finalPrice)
        optionDetails.appendChild(optionName)
        optionDetails.appendChild(priceDetails)
        label.appendChild(input)
        label.appendChild(optionDetails)
        li.appendChild(label)

        if ((!isSoldOut && !hasCheckedOption) || isLastSelected) {
          hasCheckedOption = true
        }
        variantsList.appendChild(li)
        hasOneTimeOptions = true
      })

      oneTimeSection.appendChild(variantsList)
      if (hasOneTimeOptions) {
        container.appendChild(oneTimeSection)
      }

      // Add confirm button
      const confirmButton = document.createElement('button')
      confirmButton.className = 'confirm-change-button button'

      confirmButton.innerHTML = `
                <div class="loading-animation"> <div class="loading-animation-spinner"></div> </div>
                <span>
                    Add
                </span>
            `
      confirmButton.addEventListener('click', () => {
        const selectedOption = container.querySelector(
          `input[name="purchase_option_${tooltipId}"]:checked`
        )
        if (selectedOption) {
          // Add loading state to button
          confirmButton.classList.add('is-loading')

          const { variantId, sellingPlanId } = selectedOption.dataset
          updateCart(variantId, confirmButton, sellingPlanId || null).catch(
            () => {
              // Error is already logged in updateCart
            }
          )
        }
      })
      container.appendChild(confirmButton)

      // Add event listeners to all radio inputs in this container
      const allRadios = container.querySelectorAll(
        `input[name="purchase_option_${tooltipId}"]`
      )
      allRadios.forEach((radioInput) => {
        radioInput.addEventListener('change', (e) => {
          // First uncheck all radios
          const tooltipRadios = container.querySelectorAll(
            `input[name="purchase_option_${tooltipId}"]`
          )
          tooltipRadios.forEach((currentRadio) => {
            currentRadio.checked = false
          })

          // Then check the selected one
          e.target.checked = true

          const { variantId, sellingPlanId } = e.target.dataset
          const newOption = {
            value: e.target.value,
            variantId,
            sellingPlanId,
          }
          lastSelectedOptions.set(productId, newOption)
          hasCheckedOption = true

          // Force a re-render of the radio state
          requestAnimationFrame(() => {
            e.target.checked = true
          })
        })
      })
    }

    // Create options for tooltip
    createPurchaseOptions(tooltipContent)
    tooltip.appendChild(tooltipContent)

    // Check if we're in custom-products section
    const customProductsSection = card.closest('.custom-product-cards')
    if (customProductsSection) {
      // Generate unique identifier for custom-products section
      const uniqueId = `custom-product-${productId}-${Math.random().toString(36).substr(2, 9)}`
      card.dataset.tooltipId = uniqueId
      tooltip.dataset.cardId = uniqueId

      // Append tooltip to the custom-product-cards container
      customProductsSection.appendChild(tooltip)
    } else {
      // Original behavior for other sections
      const buttonGroup = card.closest('.button-group')
      if (buttonGroup) {
        buttonGroup.appendChild(tooltip)
      }
    }

    // Add click event listener
    card.addEventListener('click', (e) => {
      e.preventDefault()

      // Check if product has only one default variant
      const [clickedVariant] = variants
      const { currentVariantId: clickedVariantId } = card.dataset
      const hasOnlyOneVariant =
        variants.length === 1 &&
        clickedVariant.id.toString() === clickedVariantId &&
        (!groups || groups.length === 0)

      if (hasOnlyOneVariant) {
        // Add loading state to button
        card.classList.add('is-loading')

        // Add loading animation after the span
        const loadingSpinner = document.createElement('div')
        loadingSpinner.className = 'loading-animation'
        loadingSpinner.innerHTML =
          '<div class="loading-animation-spinner"></div>'
        card.appendChild(loadingSpinner)

        // Directly add to cart
        updateCart(clickedVariant.id, card, null)
          .catch(() => {
            // Error is already logged in updateCart
          })
          .finally(() => {
            // Remove loading state and animation
            card.classList.remove('is-loading')
            const spinner = card.querySelector('.loading-animation')
            if (spinner) {
              spinner.remove()
            }
          })
        return
      }

      // Check if we're on mobile
      const isMobile = window.innerWidth <= 768

      if (isMobile) {
        // Clear previous content
        modalPlans.innerHTML = ''

        // Create new content for this card
        createPurchaseOptions(modalPlans)

        // Add active class to atc-card
        card.classList.add('active')

        // Show modal on mobile
        sellingPlanModal.style.visibility = 'visible'
        sellingPlanModal.style.opacity = '1'
        sellingPlanModal.style.display = 'flex'

        // Small delay to ensure DOM is ready
        setTimeout(() => {
          let radioToCheck
          const lastSelectedOption = lastSelectedOptions.get(productId)
          if (lastSelectedOption) {
            radioToCheck = modalPlans.querySelector(
              `input[value="${lastSelectedOption.value}"]`
            )
          }

          // Fall back to the metafield default, then to the first available option
          if ((!radioToCheck || radioToCheck.disabled) && defaultSubscribeOptionValue) {
            radioToCheck = modalPlans.querySelector(
              `input[value="${defaultSubscribeOptionValue}"]:not([disabled])`
            )
          }
          if (!radioToCheck || radioToCheck.disabled) {
            const radioName = `purchase_option_${tooltipId}`
            radioToCheck = modalPlans.querySelector(
              `input[name="${radioName}"]:not([disabled])`
            )
          }

          if (radioToCheck) {
            // Uncheck all radios first
            const tooltipRadios = modalPlans.querySelectorAll(
              `input[name="purchase_option_${tooltipId}"]`
            )
            tooltipRadios.forEach((radio) => {
              radio.checked = false
            })
            // Then check the selected one without triggering change event
            radioToCheck.checked = true
          }
        }, 50)
        return
      }

      // Desktop behavior
      card.classList.toggle('active')
      tooltip.classList.toggle('active')

      // If tooltip is being shown, ensure correct checked state
      if (tooltip.classList.contains('active')) {
        // Small delay to ensure DOM is ready
        setTimeout(() => {
          let radioToCheck
          const lastSelectedOption = lastSelectedOptions.get(productId)

          if (lastSelectedOption) {
            radioToCheck = tooltipContent.querySelector(
              `input[value="${lastSelectedOption.value}"]`
            )
          }

          // Fall back to the metafield default, then to the first available option
          if ((!radioToCheck || radioToCheck.disabled) && defaultSubscribeOptionValue) {
            radioToCheck = tooltipContent.querySelector(
              `input[value="${defaultSubscribeOptionValue}"]:not([disabled])`
            )
          }
          if (!radioToCheck || radioToCheck.disabled) {
            const radioName = `purchase_option_${tooltipId}`
            radioToCheck = tooltipContent.querySelector(
              `input[name="${radioName}"]:not([disabled])`
            )
          }

          if (radioToCheck) {
            // Uncheck all radios first
            const tooltipRadios = tooltipContent.querySelectorAll(
              `input[name="purchase_option_${tooltipId}"]`
            )
            tooltipRadios.forEach((radio) => {
              radio.checked = false
            })
            // Then check the selected one without triggering change event
            radioToCheck.checked = true
          }
        }, 50)
      }

      if (window.innerWidth > 768) {
        // Only on desktop
        // Check if we're in custom-products section
        if (customProductsSection) {
          // Get the position of the card relative to the viewport
          const cardRect = card.getBoundingClientRect()
          const customProductsRect =
            customProductsSection.getBoundingClientRect()

          // Get the atc-card element
          const atcCard = card
          if (!atcCard) return // Exit if no atc-card found

          const atcCardRect = atcCard.getBoundingClientRect()

          // Position the tooltip relative to the card
          tooltip.style.position = 'absolute'
          // Center horizontally relative to the atc-card
          tooltip.style.left = `${atcCardRect.left - customProductsRect.left + atcCardRect.width / 2 - tooltip.offsetWidth / 2}px`
          // Add 10px adjustment to vertical position
          tooltip.style.top = `${cardRect.bottom - customProductsRect.top + 10}px`

          // Reset to default
          tooltip.style.bottom = 'auto'
          tooltip.classList.add('upward')

          // Check if tooltip would be cut off at the bottom
          const tooltipRect = tooltip.getBoundingClientRect()
          if (tooltipRect.bottom > window.innerHeight) {
            // If tooltip is cut off at the bottom, show it above the card with 10px adjustment
            tooltip.style.top = `${cardRect.top - customProductsRect.top - tooltipRect.height - 10}px`
            tooltip.classList.remove('upward')
          }
        } else {
          // Original behavior for other sections
          // Reset to default
          tooltip.style.bottom = '52%'
          tooltip.style.top = 'auto'
          tooltip.classList.remove('upward')
          // Force reflow to get updated position
          const rect = tooltip.getBoundingClientRect()
          if (rect.top < 0) {
            // If tooltip is cut off at the top, show it below
            tooltip.style.top = '106%'
            tooltip.style.bottom = 'auto'
            tooltip.classList.add('upward')
          }
        }
      }
    })
  })
}

export default cardTooltip
